import { render, staticRenderFns } from "./GlobalFileViewer.vue?vue&type=template&id=4e28f053"
import script from "./GlobalFileViewer.vue?vue&type=script&lang=js"
export * from "./GlobalFileViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports